import React from 'react'
import Container from '../../../../components/Container'
import { FormSaleTable } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const SaleTableCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormSaleTable typeForm="create" />
  </Container>
)

export default SaleTableCreate
